import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";
// service
import { createVehicle } from "../../../utils/services/vehicles";
import { getParticipants } from "../../../utils/services/participants";
import { getGroups } from "../../../utils/services/group";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// axios
import axios from "axios";
// telefone
import { PhoneInput } from "react-international-phone";
import { paisesPt } from "../../../utils/helpers/data/countries";

const listTypeVehicles = [
  { label: "Carro", value: "Carro" },
  { label: "Ônibus", value: "Ônibus" },
  { label: "Van", value: "Van" },
];

function ModalNewVehicle(props) {
  const { isOpen, toggle } = props;
  const [isLoading, setIsloading] = useState(false);
  //confirmação
  const [success_dlg, setsuccess_dlg] = useState(false);
  // erro
  const [erroForm, setErroForm] = useState({});
  // lista de Participants
  const [allParticipants, setAllParticipants] = useState([]);
  // lista de opções de local
  const [localizationOptionsOrigin, setLocalizationOptionsOrigin] = useState(
    [],
  );
  const [localizationOptionsDestination, setLocalizationOptionsDestination] =
    useState([]);
  // exibir as opções de localizações
  const [googleOptions, setGoogleOptions] = useState(true);
  // form
  const [transferType, setTransferType] = useState("");
  const [description, setDescription] = useState();
  const [origin, setOrigin] = useState();
  const [destination, setDestination] = useState();
  const [editLatLonOrigem, setEditLatLonOrigem] = useState(false);
  const [editLatLonDestino, setEditLatLonDestino] = useState(false);
  const [departureLongitude, setDepartureLongitude] = useState();
  const [departureLatitude, setDepartureLatitude] = useState();
  const [arrivalLongitude, setArrivalLongitude] = useState();
  const [arrivalLatitude, setArrivalLatitude] = useState();
  const [departureDatetime, setDepartureDatetime] = useState();
  const [arrivalDatetime, setArrivalDatetime] = useState();
  const [departureTime, setDepartureTime] = useState();
  const [arrivalTime, setArrivalTime] = useState();
  const [driverName, setDriverName] = useState();
  const [coordinatorName, setCoordinatorName] = useState("");
  const [coordinatorPhone, setCoordinatorPhone] = useState("");
  const [vehicleType, setVehicleType] = useState();
  const [notes, setNotes] = useState();
  const [seatingCapacity, setSeatingCapacity] = useState();
  const [company, setCompany] = useState();
  const [meetingPoint, setMeetingPoint] = useState();
  const [phone, setPhone] = useState();
  const [participantsSelecteds, setParticipantsSelecteds] = useState([]);
  //state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  const [groupsMulti, setGroupsMulti] = useState([]);

  function checkDateTimeInterval() {
    const isValidDate = (d) => d && d !== "";
    const isValidTime = (t) => t && t !== "";

    const hasStartDate = isValidDate(departureDatetime);
    const hasEndDate = isValidDate(arrivalDatetime);
    const hasStartHour = isValidTime(departureTime);
    const hasEndHour = isValidTime(arrivalTime);

    const startDateTime =
      hasStartDate && hasStartHour
        ? new Date(`${departureDatetime}T${departureTime}`)
        : null;

    const endDateTime =
      hasEndDate && hasEndHour
        ? new Date(`${arrivalDatetime}T${arrivalTime}`)
        : null;

    if (
      startDateTime &&
      hasEndDate &&
      !hasEndHour &&
      departureDatetime > arrivalDatetime
    ) {
      return false;
    }

    if (startDateTime && (!hasEndDate || !hasEndHour)) {
      return true;
    }

    if (
      (startDateTime && endDateTime && endDateTime >= startDateTime) ||
      (startDateTime && !endDateTime && !arrivalTime)
    ) {
      return true;
    }

    return false;
  }

  function verifyErros() {
    if (!transferType) {
      setErroForm({ transferType: "O campo Tipo de transfer é obrigatório" });
      return;
    } else setErroForm({});

    if (!description) {
      setErroForm({ name: "O campo Nome é obrigatório" });
      return;
    } else setErroForm({});

    if (!origin) {
      setErroForm({ origin: "O campo Origem é obrigatório" });
      return;
    } else setErroForm({});

    if (!destination) {
      setErroForm({ destination: "O campo Destino é obrigatório" });
      return;
    } else setErroForm({});

    if (!departureDatetime) {
      setErroForm({ departureDatetime: "O campo Data da Saída é obrigatório" });
      return;
    } else setErroForm({});

    if (!departureTime) {
      setErroForm({ departureTime: "O campo Hora da Saída é obrigatório" });
      return;
    } else setErroForm({});

    if (!arrivalDatetime && arrivalTime) {
      setErroForm({
        arrivalDatetime:
          "Com a inclusão da Hora da chegada o campo Data da Chegada é obrigatório",
      });
      return;
    } else setErroForm({});

    if (arrivalDatetime && !arrivalTime) {
      setErroForm({
        arrivalTime:
          "Com a inclusão da Data da Chegada o campo Hora da chegada é obrigatório",
      });
      return;
    } else setErroForm({});

    if (!checkDateTimeInterval()) {
      setErroForm({
        arrivalDatetime:
          "A Data e Hora da Chegada não pode ser menor que a Data e Hora da Saída.",
      });
      return;
    } else setErroForm({});

    if (!seatingCapacity || seatingCapacity < 1) {
      setErroForm({
        seatingCapacity: "O campo Capacidade do veículo é obrigatório",
      });
      return;
    } else setErroForm({});

    if (seatingCapacity < participantsSelecteds.length) {
      setErroForm({
        seatingCapacity:
          "A Capacidade do veículo deve ser maior que a quantidade de participantes",
      });
      return;
    } else setErroForm({});

    if (phone.slice(0, 3) === "+55") {
      const onlyNumbers = phone.replace(/\D+/g, "");
      if (onlyNumbers.length > 2 && onlyNumbers.length < 12) {
        setErroForm({
          phone:
            "O campo Telefone para o Brasil precisa ter no mínimo 8 caracteres.",
        });
        return;
      } else setErroForm({});
    } else setErroForm({});

    if (coordinatorPhone.slice(0, 3) === "+55") {
      const onlyNumbers = coordinatorPhone.replace(/\D+/g, "");
      if (onlyNumbers.length > 2 && onlyNumbers.length < 12) {
        setErroForm({
          coordinatorPhone:
            "O campo Telefone para o Brasil precisa ter no mínimo 8 caracteres.",
        });
        return;
      } else setErroForm({});
    } else setErroForm({});

    submitForm();
  }

  function submitForm() {
    var data = {
      transferType: transferType,
      eventId: props.idEvent,
      description,
      origin: origin,
      destination: destination,
      departureLongitude: parseFloat(departureLongitude) ?? null,
      departureLatitude: parseFloat(departureLatitude) ?? null,
      arrivalLongitude: parseFloat(arrivalLongitude) ?? null,
      arrivalLatitude: parseFloat(arrivalLatitude) ?? null,
      departureDatetime:
        departureDatetime && departureTime
          ? `${departureDatetime}T${departureTime}`
          : null,
      arrivalDatetime:
        arrivalDatetime && arrivalTime
          ? `${arrivalDatetime}T${arrivalTime}`
          : null,
      driverName,
      coordinatorName,
      coordinatorPhone,
      vehicleType,
      seatingCapacity: parseInt(seatingCapacity),
      company,
      meetingPoint,
      phone,
      notes,
      participants: participantsSelecteds.map((e) => {
        return e.value;
      }),
      grupos:
        groupsMulti.length > 0 && groupsMulti[0].value === "todos"
          ? groups.map((e) => {
              return e.id;
            })
          : groupsMulti.map((e) => {
              return e.value;
            }),
    };

    setIsloading(true);

    createVehicle(data)
      .then((res) => {
        setIsloading(false);

        if (res.message === "created") {
          setsuccess_dlg(true);
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
        console.log("erro", error);
      });
  }

  function getLocalizations(e, setState) {
    axios
      .get(
        `https://us-central1-inteegra-ping.cloudfunctions.net/GoogleAutoComplete?search=${e}&language=pt`,
      )
      .then((localizations) => {
        if (localizations?.data?.success?.status === "OK")
          setState(localizations.data.success.predictions);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  function getAllParticipants() {
    getParticipants({
      idEvent: props.idEvent,
      offset: 1,
      limit: 10000,
      search: "",
      columnSearch: "login",
      status: "ATIVO",
    }).then((res) => {
      if (res.message === "users") {
        setAllParticipants(res.data.data);
      }
    });
    // .catch((error) => console.log("erro", error));
  }

  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  async function getGroupsFunc() {
    await getGroups({
      jwt: "",
      eventId: props.idEvent,
      offset: 1,
      limit: 0,
      search: "",
    })
      .then((response) => {
        setGroups(response.findOneGroupData.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  useEffect(() => {
    getAllParticipants();
    getGroupsFunc();
  }, []);

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggleBackdrop();
        }}
        autoFocus={true}
        centered={true}
        size="lg"
      >
        {success_dlg ? (
          <SweetAlert
            success
            title={"Criado"}
            onConfirm={() => {
              setsuccess_dlg(false);
              toggle();
              setTimeout(() => {
                props.getAllVehicles();
              }, 1000);
            }}
          >
            {"Veículo criado com sucesso!"}
          </SweetAlert>
        ) : null}
        <ModalHeader toggle={toggle}>Novo Veículo</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label">Tipo de transfer *</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setTransferType(
                      e.target.value.toUpperCase().replace(" ", ""),
                    )
                  }
                  value={transferType}
                />
                {erroForm.transferType && (
                  <a style={{ color: "red" }}>{erroForm.transferType}</a>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Nome *</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setDescription(e.target.value)}
                />
                {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div className="form-check form-switch">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`checkGoogle`}
                  checked={googleOptions}
                  onChange={(e) => {
                    setGoogleOptions(e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor={`checkGoogle`}>
                  Usar serviços de localização da Google
                </label>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Origem *</label>
                <input
                  className="form-control"
                  type="text"
                  id="localInputOrigem"
                  value={origin}
                  onChange={(e) => {
                    setOrigin(e.target.value);
                    setDepartureLatitude("");
                    setDepartureLongitude("");
                    if (googleOptions)
                      getLocalizations(
                        e.target.value,
                        setLocalizationOptionsOrigin,
                      );
                  }}
                />
                {erroForm.origin && (
                  <p style={{ color: "red" }}>{erroForm.origin}</p>
                )}
              </div>
              {googleOptions &&
                origin &&
                localizationOptionsOrigin &&
                localizationOptionsOrigin.length > 0 && (
                  <ul className="localization">
                    {localizationOptionsOrigin.map((l) => {
                      return (
                        <li
                          key={l.description}
                          className="localizationLi"
                          onClick={() =>
                            setOrigin(l.description) >
                            setLocalizationOptionsOrigin([])
                          }
                        >
                          {l.description}
                        </li>
                      );
                    })}
                  </ul>
                )}
            </Col>

            <Row>
              <Col md={12}>
                <div
                  className="form-check form-switch"
                  style={{
                    borderTop: "1px solid #dbdbdb",
                    borderBottom: "1px solid #dbdbdb",
                    marginTop: 5,
                    marginBottom: 5,
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`checkLatLonOrigem`}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setEditLatLonOrigem(true);
                      } else setEditLatLonOrigem(false);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`checkLatLonOrigem`}
                  >
                    Editar Latitude/Longitude de Origem
                  </label>
                </div>
              </Col>
            </Row>
            {editLatLonOrigem && (
              <>
                <Row style={{ marginTop: "10px" }}>
                  <Col md={6}>
                    <div>
                      <label className="form-label">Latitude de origem </label>
                      <input
                        className="form-control"
                        type="text"
                        onChange={(e) => setDepartureLatitude(e.target.value)}
                      />
                      {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.origin}</p>
                )} */}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div>
                      <label className="form-label">Longitude de origem</label>
                      <input
                        className="form-control"
                        type="text"
                        onChange={(e) => setDepartureLongitude(e.target.value)}
                      />
                      {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )} */}
                    </div>
                  </Col>
                </Row>
              </>
            )}
            <Col md={12}>
              <div style={{ marginTop: "10px" }}>
                <label className="form-label">Destino *</label>
                <input
                  className="form-control"
                  type="text"
                  id="localInputDestino"
                  value={destination}
                  onChange={(e) => {
                    setDestination(e.target.value);
                    setArrivalLatitude("");
                    setArrivalLongitude("");

                    if (googleOptions)
                      getLocalizations(
                        e.target.value,
                        setLocalizationOptionsDestination,
                      );
                  }}
                />
                {erroForm.destination && (
                  <p style={{ color: "red" }}>{erroForm.destination}</p>
                )}
              </div>

              {googleOptions &&
                destination &&
                localizationOptionsDestination &&
                localizationOptionsDestination.length > 0 && (
                  <ul className="localization">
                    {localizationOptionsDestination.map((l) => {
                      return (
                        <li
                          key={l.description}
                          className="localizationLi"
                          onClick={() =>
                            setDestination(l.description) >
                            setLocalizationOptionsDestination([])
                          }
                        >
                          {l.description}
                        </li>
                      );
                    })}
                  </ul>
                )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div
                className="form-check form-switch"
                style={{
                  borderTop: "1px solid #dbdbdb",
                  borderBottom: "1px solid #dbdbdb",
                  marginTop: 5,
                  marginBottom: 5,
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`checkLatLonDestino`}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setEditLatLonDestino(true);
                    } else setEditLatLonDestino(false);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={`checkLatLonDestino`}
                >
                  Editar Latitude/Longitude de Destino
                </label>
              </div>
            </Col>
          </Row>
          {editLatLonDestino && (
            <Row style={{ marginTop: "10px" }}>
              <Col md={6}>
                <div>
                  <label className="form-label">Latitude de destino </label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => setArrivalLatitude(e.target.value)}
                  />
                  {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.origin}</p>
                )} */}
                </div>
              </Col>
              <Col md={6}>
                <div>
                  <label className="form-label">Longitude de destino</label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => setArrivalLongitude(e.target.value)}
                  />
                  {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )} */}
                </div>
              </Col>
            </Row>
          )}
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Data da Saída *</label>
                <input
                  className="form-control"
                  onChange={(e) => setDepartureDatetime(e.target.value)}
                  type="date"
                  id="example-datetime-local-input"
                />
                {erroForm.departureDatetime && (
                  <p style={{ color: "red" }}>{erroForm.departureDatetime}</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Hora da saída *</label>
                <input
                  className="form-control"
                  type="time"
                  id="example-datetime-local-input"
                  onChange={(e) => setDepartureTime(e.target.value)}
                />
                {erroForm.departureTime && (
                  <p style={{ color: "red" }}>{erroForm.departureTime}</p>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Data da Chegada </label>
                <input
                  className="form-control"
                  onChange={(e) => setArrivalDatetime(e.target.value)}
                  type="date"
                  id="example-datetime-local-input"
                  min={departureDatetime || ""}
                />
                {erroForm.arrivalDatetime && (
                  <p style={{ color: "red" }}>{erroForm.arrivalDatetime}</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Hora da chegada</label>
                <input
                  className="form-control"
                  type="time"
                  id="example-datetime-local-input"
                  onChange={(e) => setArrivalTime(e.target.value)}
                />
                {erroForm.arrivalTime && (
                  <p style={{ color: "red" }}>{erroForm.arrivalTime}</p>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Capacidade do veículo *</label>
                <input
                  className="form-control"
                  type="number"
                  onChange={(e) => setSeatingCapacity(e.target.value)}
                />
                {erroForm.seatingCapacity && (
                  <p style={{ color: "red" }}>{erroForm.seatingCapacity}</p>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            {/* <Col md={12}>
              <div>
                <label className="form-label">Tipo de veículo</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setVehicleType(e.target.value)}
                />
                
              </div>
            </Col> */}
            <Col lg={12}>
              <label className="form-label">Tipo de veículo</label>
              <Select
                placeholder={"Selecione um tipo de veículo..."}
                isClearable={true}
                onChange={(e, actionMeta) => {
                  if (actionMeta.action === "clear") {
                    setVehicleType("");
                  } else {
                    setVehicleType(e.value);
                  }
                }}
                options={[
                  {
                    options: [
                      ...listTypeVehicles?.map((e) => {
                        return { label: e.label, value: e.value };
                      }),
                    ],
                  },
                ]}
                classNamePrefix="select2-selection"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                    overflowY: "auto",
                  }),
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Empresa</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCompany(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Nome do motorista</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setDriverName(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Telefone do motorista</label>
                <PhoneInput
                  defaultCountry="br"
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  countries={paisesPt}
                  inputStyle={{ width: "100%" }}
                />
                {erroForm.phone && (
                  <a style={{ color: "red" }}>{erroForm.phone}</a>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Nome do coordenador</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCoordinatorName(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Telefone do coordenador</label>
                <PhoneInput
                  defaultCountry="br"
                  onChange={(phone) => setCoordinatorPhone(phone)}
                  countries={paisesPt}
                  inputStyle={{ width: "100%" }}
                />
                {erroForm.coordinatorPhone && (
                  <a style={{ color: "red" }}>{erroForm.coordinatorPhone}</a>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Ponto de encontro</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setMeetingPoint(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Observações</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Participantes</label>
                <Select
                  placeholder={"Selecione"}
                  isMulti={true}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  onChange={(e) => setParticipantsSelecteds(e)}
                  options={[
                    {
                      options: allParticipants.map((e) => ({
                        label: e.nome,
                        value: e.id,
                      })),
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  placeholder={"Selecione"}
                  isMulti={true}
                  value={groupsMulti}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  onChange={(e) => handleGroupMulti(e)}
                  options={[
                    {
                      options:
                        groups?.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              onClick={verifyErros}
            />
          </Row>
        </ModalBody>
      </Modal>
      {/* <Instructions
        isOpen={modalInstructions}
        toggle={() => {
          setModalInstructions(!modalInstructions);
        }}
      /> */}
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalNewVehicle);
